'use client'

import type { GetMarketingCapabilitiesOutputDTO } from '@algoacademy/backend/modules/app/account/endpoints/queries/get-marketing-capabilities/output.dto'
import { createContext } from 'react'

export const NO_MARKETING_CAPABILITIES: GetMarketingCapabilitiesOutputDTO = {
  canManageSite: false,
  canManagePayments: false,
  canManageMentors: false,
  canOpenOwnMentorCard: false
}

export const MarketingCapabilitiesContext = createContext<GetMarketingCapabilitiesOutputDTO | null>(
  null
)
